'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';
import { useFormContext } from '@/app/[locale]/(form)/components/FormProvider';
import { MultipleContributionReport } from '@/app/[locale]/(form)/components/Survey/MultipleContributionReport';
import { getLangAttributeValue } from '@/app/utils/entities/translation';
import { AcceptLanguage } from '~/const/locale';
import { InteractionForm } from '../Form/InteractionForm';

export const Survey = ({ formPreview = false }: { formPreview?: boolean }) => {
  const locale = useLocale();

  const { interaction } = useFormContext();
  const [interactionTranslated, setInteractionTranslated] = useState(false);

  const canHaveMultipleContributions = interaction?.can_have_multiple_contributions;
  const originalLocale = interaction?.original_locale;

  const langValue = getLangAttributeValue(
    originalLocale,
    AcceptLanguage[locale],
    interactionTranslated,
  );

  const getTranslationInteraction = () => {
    setInteractionTranslated(!interactionTranslated);
  };

  return (
    <InteractionForm
      canHaveMultipleContributions={canHaveMultipleContributions}
      formPreview={formPreview}
      getTranslation={getTranslationInteraction}
      interaction={interaction}
      languageToDisplay={AcceptLanguage[locale]}
      langValue={langValue}
      translated={interactionTranslated}
      userLanguage={AcceptLanguage[locale]}
    >
      {interaction.can_have_multiple_contributions && (
        <MultipleContributionReport />
      )}
    </InteractionForm>
  );
};
